import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './ModelCategory.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import { initialModelCategoryState } from '../../reducers/initialState';

import Pagination from '../Pagination/Pagination';
import { DEFAULT_PAGE_SIZE } from '../../constants';
import ModelCategoryListTable from '../ModelCategory/ModelCategoryListTable';
import { IsWidgetAccessible, WidgetVisibility } from '../../utils/widgetManager';
import SearchBar from '../SearchBar/SearchBar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OperationalSetupContentTemplate from '../OperationalSetup/OperationalSetupContentTemplate';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';


import Cookies from 'js-cookie';

const ModelCategoryList = ({
  getModelCategories,
  setCurrentPage,
  setFilterData,
  modelCategoryManager = {
    ...initialModelCategoryState.modelCategoryManager
  },
  intl,
  userProfileWidgets,
  userModelCategories,
  cleanUp,
  currentTimezone
}) => {
  let filter = modelCategoryManager.filter || '';
  let offset = modelCategoryManager.offset || 0;
  let limit = modelCategoryManager.limit || 1000;
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;
  let organisationId = Cookies.get(`selectedorganisationid-${envName}`) || 1;

  useEffect(() => {
    getModelCategories(offset, limit, filter, organisationId);
  }, [getModelCategories, offset, limit, filter, organisationId]);


  //clean up
  useEffect(() => {
    return () => {
      cleanUp({ ...initialModelCategoryState });
    };
  }, []);


  const onPageChangeHandler = currentPage => {
    setCurrentPage(currentPage);
  };

  const searchHandler = value => {
    setCurrentPage(1);
    filteredResults(value);
  };

  const filteredResults = value => {
    let filteredList = modelCategoryManager.modelCategories;

    if (value !== '') {
      filteredList = filteredList.filter(function (item) {
        return item.Name.toLowerCase().includes(value.toLowerCase());
      });
    }

    setFilterData({ filteredResults: { filteredResults: filteredList } });
  };

  const modelObj = Object.values(modelCategoryManager.filteredResults);

  let messageId = (modelCategoryManager && modelCategoryManager.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  const isUpdateAllowed = IsWidgetAccessible(userProfileWidgets, 'MODELCATEGORY_UPDATE');
  const isDuplicateAllowed = IsWidgetAccessible(userProfileWidgets, 'MODELCATEGORY_DUPLICATE');
  const isConfigurationAllowed = IsWidgetAccessible(userProfileWidgets, 'MODELCATEGORY_CONFIGURE');

  return (
    <div className={s.modelCategoryList}>
      {modelCategoryManager.isLoading && <LoadingSpinner />}
      <Banner
        failureText={messageText}
        showBanner={modelCategoryManager.showBanner}
        status={modelCategoryManager.isOpSuccessful}
        successText={messageText}
      />
      <OperationalSetupContentTemplate selectedPage="manageModelCategory" userProfileWidgets={userProfileWidgets}>
        <div className={s.contentWrapper}>
          <div className={s.modelHeader}>
            <div className={s.subHeading}>
              <FormattedMessage id="modelcategory.modelcategory" defaultMessage="Model Category" />
              <span data-unittest="modelDataCount" className={s.circle}>
                {modelCategoryManager.modelCategories.length}
              </span>
            </div>
          </div>

          <Row>
            <Col sm={6} lg={4}>
              <SearchBar
                searchHandler={searchHandler}
                clearSearchInVisible={false}
                initialText={filter}
                placeHolderTextId="modelcategory.ModelCategoryName"
              />
            </Col>
            <Col sm={6} lg={8}>
              <Link to={`/operational-setup/model-category`}>
                <Button className={s.addbutton} style={WidgetVisibility(userProfileWidgets, `MODELCATEGORY_ADD`)}>
                  + <FormattedMessage id="modelcategory.addNew" defaultMessage="ADD NEW" />
                </Button>
              </Link>
            </Col>
          </Row>
          <div className="">
            <Pagination
              data={modelObj}
              pageSize={DEFAULT_PAGE_SIZE}
              onPageChange={onPageChangeHandler}
              startingPage={modelCategoryManager.currentPage}
            >
              <ModelCategoryListTable
                UpdateAllowed={isUpdateAllowed}
                DuplicateAllowed={isDuplicateAllowed}
                ConfigurationAllowed={isConfigurationAllowed}
                currentTimezone={currentTimezone}
                UserModelCategories={userModelCategories}
              />
            </Pagination>
          </div>
        </div>
      </OperationalSetupContentTemplate>
    </div>
  );
};


ModelCategoryList.propTypes = {
  getModelCategories: PropTypes.func.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  setPageFilter: PropTypes.func.isRequired,
  currentTimezone: PropTypes.string.isRequired
};

export default injectIntl(ModelCategoryList);
